/* EYVA — shared behaviours. Load once:  {{ 'eyva-base.js' | asset_url | script_tag }}
   Idempotent: safe to include multiple times. Handles scroll-reveal for any
   element with .eyva-reveal, and re-scans when sections load in the theme editor. */
(function () {
  if (window.__eyvaBaseInit) return;
  window.__eyvaBaseInit = true;

  document.documentElement.classList.remove('no-js');

  var reveal = function (root) {
    var els = (root || document).querySelectorAll('.eyva-reveal:not(.eyva-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eyva-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('eyva-in'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  };

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  // Shopify theme editor: reveal newly added / re-rendered sections immediately.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.eyva-reveal').forEach(function (el) { el.classList.add('eyva-in'); });
  });
})();
